import { normalizeRole } from './commandCentreAccess';

export { normalizeRole };

export const isAdministratorRole = (role?: string | null): boolean => {
  const normalized = normalizeRole(role);
  return normalized === 'administrator' || normalized === 'admin' || normalized === 'super-administrator';
};
